import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  AMENITIES_SECTION_CREATE,
  AMENITIES_SECTION_EDIT,
  AMENITIES_SECTION_VIEW,
  AMENITIES_CATEGORY_CREATE,
  AMENITIES_CATEGORY_EDIT,
  AMENITIES_CATEGORY_VIEW,
  AMENITY_TYPE_AMENITIES,
  AMENITY_TYPE_SECTION,
  AMENITY_TYPE_CATEGORY,
  AMENITIES_CREATE,
  AMENITIES_EDIT,
  AMENITIES_VIEW,
} from '../../../constants/AmenityConst';
import { useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../property/propertySlice';
import { useHistory } from 'react-router';
import { Drawer, Button } from '@material-ui/core';
import AmenityCategoryList from './amenity-categories/category-list/Amenity-Category-List';
import AmenitySectionList from './amenity-sections/section-list/Amenity-Section-List';
import AmenitiesList from './amenities/amenities-list/Amenities-List';
import AmenityCategoryCreate from './amenity-categories/category-create/Category-Create';
import AmenitySectionCreate from './amenity-sections/section-create/Section-Create';
import AmenityCategoryView from './amenity-categories/category-view/Amenity-Category-View';
import AmenitySectionView from './amenity-sections/section-view/Amenity-Section-View';
import AmenitiesCreate from './amenities/amenities-create/Amenities-Create';
import AmenitiesView from './amenities/amenities-view/Amenities-View';
import { validateUserSession } from '../../../utils/authUtils';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Amenities = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(AMENITY_TYPE_SECTION);
  const [state, setState] = useState(
    {
      type: AMENITIES_CATEGORY_CREATE,
      status: false,
    },
    {
      type: AMENITIES_SECTION_CREATE,
      status: false,
    },
  );
  const selectedHotel = useSelector(selectedHotelSelector);

  const [viewState, setViewState] = useState({
    type: AMENITIES_CATEGORY_VIEW,
    status: false,
    obj: null,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const history = useHistory();

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    if (
      activeTab === AMENITY_TYPE_SECTION ||
      activeTab === AMENITY_TYPE_CATEGORY ||
      activeTab === AMENITY_TYPE_AMENITIES
    ) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(AMENITY_TYPE_CATEGORY);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(AMENITY_TYPE_CATEGORY);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case AMENITIES_SECTION_CREATE:
        return (
          <AmenitySectionCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></AmenitySectionCreate>
        );
      case AMENITIES_SECTION_EDIT:
        return (
          <AmenitySectionCreate
            toggleDrawer={onDrawerToggle}
            section={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></AmenitySectionCreate>
        );

      case AMENITIES_CATEGORY_CREATE:
        return (
          <AmenityCategoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></AmenityCategoryCreate>
        );
      case AMENITIES_CATEGORY_EDIT:
        return (
          <AmenityCategoryCreate
            toggleDrawer={onDrawerToggle}
            category={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></AmenityCategoryCreate>
        );
      case AMENITIES_CREATE:
        return (
          <AmenitiesCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></AmenitiesCreate>
        );
      case AMENITIES_EDIT:
        return (
          <AmenitiesCreate
            toggleDrawer={onDrawerToggle}
            amenity={state.obj}
            hotelId={selectedHotel}
            showLoader={showLoader}
          ></AmenitiesCreate>
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case AMENITIES_SECTION_VIEW:
        return (
          <AmenitySectionView
            amenitiesSection={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></AmenitySectionView>
        );
      case AMENITIES_CATEGORY_VIEW:
        return (
          <AmenityCategoryView
            amenitiesCategory={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></AmenityCategoryView>
        );
      case AMENITIES_VIEW:
        return (
          <AmenitiesView
            amenity={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></AmenitiesView>
        );

      default:
        break;
    }
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state?.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState?.status && <>{switchViewContent(viewState)}</>}
      {!viewState?.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Hotel Compendium</span>
            </div>
            <div className='col-md-6 d-flex justify-content-end'>
              {/* sync button might come in the future sprint */}
              {/* <IconButton
                className="shadow"
              >
                <CloudCircleIcon />
              </IconButton> */}
            </div>
          </div>

          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === AMENITY_TYPE_SECTION ? 'outlined' : 'text'}
                className={
                  activeTab === AMENITY_TYPE_SECTION
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(AMENITY_TYPE_SECTION)}
              >
                Sections
              </Button>
              <Button
                size='large'
                variant={activeTab === AMENITY_TYPE_CATEGORY ? 'outlined' : 'text'}
                className={
                  activeTab === AMENITY_TYPE_CATEGORY
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(AMENITY_TYPE_CATEGORY)}
              >
                Category
              </Button>
              <Button
                size='large'
                variant={activeTab === AMENITY_TYPE_AMENITIES ? 'outlined' : 'text'}
                className={
                  activeTab === AMENITY_TYPE_AMENITIES
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(AMENITY_TYPE_AMENITIES)}
              >
                Hotel Compendium
              </Button>
            </div>
          </div>

          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === AMENITY_TYPE_SECTION && (
                <AmenitySectionList
                  permissions={permissions}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === AMENITY_TYPE_CATEGORY && (
                <AmenityCategoryList
                  permissions={permissions}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === AMENITY_TYPE_AMENITIES && (
                <AmenitiesList
                  permissions={permissions}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Amenities;
